import React from "react";
import  {
  Page,
  Text,
  View,
  Document,
  BlobProvider,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Spin } from "antd";
import {details_styles as styles, PDFSaved} from './PDF_Helper'
import moment from "moment";

const DisplayContent = props => {
    let i = 0
    return props.data.map(item => {
        let thisStyle = styles.detailContainerGray
        i += 1
        if (i % 2) thisStyle = styles.detailContainer
      return (
        <View key={item.contributionLineId} style={thisStyle} wrap={false}>
          <Text style={[styles.engDetails, { width: 100 } ]}>{moment(item.contributionDate).format('DD MMM YYYY')}</Text>
          <Text style={[styles.engDetails, { width: 200 }]}>{item.fund}</Text>
          <Text style={[styles.amount, { width: 80 } ] }>{item.amount.toFixed(2)}</Text>
          <Text style={[styles.amount, { width: 75 }]}>{item.rebatePercentage}</Text>
          <Text style={[styles.amount, { width: 80 }]}>{item.rebateAmount.toFixed(2)}</Text>
        </View>

      );

    })

  };

const Heading = props => {
    let OrgName = sessionStorage.getItem("OrganisationName");
    let Address = sessionStorage.getItem("Address");
    return (
      <View key='heading' style={styles.content} wrap={false}>
        <Text style={styles.heading}>{OrgName}</Text>
        <Text style={styles.address}>{Address}</Text>
        <Text style={styles.title}>Statement of Contributions</Text>
        <Text style={styles.subTitle}>Period: {props.fromDate.format('DD/MM/YYYY')} to {props.toDate.format('DD/MM/YYYY')}</Text>
        <Text style={styles.subTitleChn}>{ `(${props.member.offeringNo}) ${props.member.displayName}` } </Text>
      </View>
    );
  }

  
const TotalLine = props => {
    return (
      <View style={[styles.totalContainer, { marginTop: 5}]} >
        <Text style={[styles.engDetails, { width: 100 }]}></Text>
        <Text style={[styles.engDetails, { width: 200 }]}></Text>
        <Text style={[styles.amount, { borderTop: 1, borderBottom: 2, width: 80,  }]}>{props.totalAmount.toFixed(2)}</Text>
        <Text style={[styles.amount,{  width: 75 }]}></Text>
        <Text style={[styles.amount, { borderTop: 1, borderBottom: 2, width: 80 }]}>{props.totalRebate.toFixed(2)}</Text>

        </View>
    )
}  

const TableHeading = props => {
  return (
    <View style={styles.tableHead} >
      <Text style={{ width: 100, borderBottom: 1, }}>Date</Text>
      <Text style={{ width: 200, borderBottom: 1}}>Fund</Text>
      <Text style={{ width: 85, borderBottom: 1, textAlign: 'right', }}>Amount</Text>
      <Text style={{ width: 80, borderBottom: 1, textAlign: 'right',}}>Rebate %</Text>
      <Text style={{ width: 85, borderBottom: 1, textAlign: 'right',}}>Rebate Amount</Text>
    </View>
    )
}

const GetPage = props => {
  return props.data.map( (p) => {
    let details = props.reportData.filter(item => {
      return item.contributorId === p.contributorId
    })
    let total = details.reduce((total, i) => total + i.amount, 0)
    let totalRebate = details.reduce((total, i) => total + i.rebateAmount, 0)
    return (
      <Page size="A4" style={styles.page} key={p.contributorId}>
        <Heading fromDate={props.fromDate} toDate={props.toDate} member={p} />
        <TableHeading />
        <DisplayContent data={details} total={total} totalRebate={totalRebate} />
        <TotalLine totalAmount={total} totalRebate={totalRebate}  />
        <Text
          style={styles.footer}
          render={({ pageNumber }) => `Page ${pageNumber}`}
          fixed
        />
      </Page>)
  })
}

const GetPDF = props => {
    return (
      <Document>
        <GetPage {...props} />
      </Document>
    );
  };
  

export default function CreateAndSavePDF(props) {

    if (props.ready) {
      let endDate = props.toDate.format('DD_MM_YYYY')
      return (
        <BlobProvider document={<GetPDF {...props}  />}>
          {({ blob, url, loading, error }) => {
            if (!loading && url) {
              saveAs(blob, `contributions_${endDate}.pdf`); //
              return <PDFSaved doFinish={props.doFinish} />;
            }
            if (loading) {
              return <Spin tip="loading" spinning={true} />;
            }
            if (error) {
              console.error(error);
              return <p>An error occurred</p>;
            }
  
            return null;
          }}
        </BlobProvider>
      );
    }
    return null;
  }
  
  